import { render } from "./DictTypes.vue?vue&type=template&id=74773b2b"
import script from "./DictTypes.vue?vue&type=script&lang=js"
export * from "./DictTypes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__